import { PRICING_PAGE_TITLE } from "ui/components/PageTitle/consts";
import { Routes } from "ui/modules/navigation";
import { BreadcrumbItem } from "ui/components/Breadcrumb/types";

/** Do verzije se dolazi iz pretrage, pa put natrag mora voditi na nju, ne samo na naslovnu. */
export const PRICING_DETAIL_BREADCRUMB: BreadcrumbItem[] = [
  {
    text: PRICING_PAGE_TITLE.text,
    icon: PRICING_PAGE_TITLE.icon,
    route: Routes.PricingPageRouter,
  },
];
